import React from 'react';

export default function Profile() {
    return (
        <div className='bg-bgDark'>
            <h1 className='text-xl text-white'>Profile page</h1>
        </div>
    );
}
